import { FC, memo, SyntheticEvent, useCallback } from 'react'
import { Button, IconButton, Modal, ModalFooter, ModalHeader } from '@cargomart/ui'
import { FloatingOverlay } from '@floating-ui/react'
import IconArrowLeft from 'remixicon/icons/Arrows/arrow-left-line.svg?react'

import { ModalFormMobileProps } from './types'

const ModalFormMobile: FC<ModalFormMobileProps> = (props) => {
  const {
    handleCloseWithConfirm,
    id,
    title,
    isLoading,
    buttonLabel = 'Сохранить',
    buttonOptionalSubmit,
    buttonOptionalIcon: ButtonOptionalIcon,
    buttonOptionalLabel,
    buttonOptionalLoading,
    isDisableSubmit,
    confirmation,
    footerClassName,
    footerBefore,
    footerAfter,
    isShowFooter = true,
    onOptional,
    children,
    ...otherProps
  } = props

  const onSubmitClick = useCallback(
    (event: SyntheticEvent) => {
      if (!confirmation) {
        return
      }

      event.preventDefault()
    },
    [confirmation]
  )

  return (
    <FloatingOverlay lockScroll className="z-modal">
      <Modal
        {...otherProps}
        isCloseOnEsc
        isCloseOnOutsideClick
        isMobile
        className={footerClassName}
        id={id}
        onClose={handleCloseWithConfirm}
      >
        <ModalHeader isBgSurface isSticky className="flex flex-col justify-between p-2">
          <div className="flex items-center">
            <IconButton className="mr-2" onClick={handleCloseWithConfirm}>
              <IconArrowLeft containerSize="lg" size="sm" />
            </IconButton>
            <div className="break-all text-headline-md">{title}</div>
          </div>
          {buttonOptionalLabel && onOptional && (
            <Button
              data-test-id={`${id}Optional`}
              loading={buttonOptionalLoading}
              onClick={onOptional}
              prefix={ButtonOptionalIcon && <ButtonOptionalIcon />}
              size="nm"
              type={buttonOptionalSubmit ? 'submit' : undefined}
              variant="outline"
            >
              {buttonOptionalLabel}
            </Button>
          )}
        </ModalHeader>

        <div className="flex-grow px-4 py-2">{children}</div>

        {isShowFooter && (
          <ModalFooter isSticky className="bg-surface p-2" isBgSurface={false}>
            {footerBefore}
            <Button
              className="block w-full"
              data-test-id={`${id}Submit`}
              disabled={isDisableSubmit}
              loading={isLoading}
              onClick={onSubmitClick}
              size="lg"
              type="submit"
              variant="solid"
            >
              {buttonLabel}
            </Button>
            {footerAfter}
          </ModalFooter>
        )}
      </Modal>
    </FloatingOverlay>
  )
}

export default memo(ModalFormMobile)
